import { CallStateEnum } from '@models/call-state.model.ts';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import { TableState } from '@store/table-store/table.model.ts';

export type HandleClose = () => void;

export interface DepartmentActionParams {
  data?: any;
  id?: number;
  isActive?: boolean;
  state?: TableState;
  handleClose?: HandleClose;
}

export interface DepartmentState extends CallStateMethods {
  callState: CallStateEnum;
  getDepartmentsList: () => void;
  departments: any[];
  departmentsList: { id: number; title: string; value: string }[];
  createDepartment: (params: DepartmentActionParams) => Promise<any>;
  editDepartment: (params: DepartmentActionParams) => void;
  changeStatus: (params: DepartmentActionParams) => void;
}

interface DepartmentStateMethods extends CallStateMethodNames {
  getDepartmentsList: 'getDepartmentsList';
  createDepartment: 'createDepartment';
  editDepartment: 'editDepartment';
  changeStatus: 'changeStatus';
}

export const DEPARTMENT_INITIAL_STATE: Omit<
  DepartmentState,
  keyof DepartmentStateMethods
> = {
  callState: CallStateEnum.Init,
  departments: [],
  departmentsList: []
};
